import { render, staticRenderFns } from "./SpecialCategoryList.vue?vue&type=template&id=04e074ea&scoped=true"
import script from "./SpecialCategoryList.vue?vue&type=script&lang=js"
export * from "./SpecialCategoryList.vue?vue&type=script&lang=js"
import style0 from "./SpecialCategoryList.vue?vue&type=style&index=0&id=04e074ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e074ea",
  null
  
)

export default component.exports